import { render, staticRenderFns } from "./depManage.vue?vue&type=template&id=f069a4d4&scoped=true&"
import script from "./depManage.vue?vue&type=script&lang=js&"
export * from "./depManage.vue?vue&type=script&lang=js&"
import style0 from "./depManage.vue?vue&type=style&index=0&id=f069a4d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f069a4d4",
  null
  
)

export default component.exports